'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _url = require('../../../util/url');

var _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Transforms the data in a Redux Form component to the format required by the API.
 * The data should be in the form given by this.props.values in the connected Redux Form
 *   component.
 * @param {Object} formValues - The form values to transform.
 * @returns {Array} - Array of transformed applicants.
 */
exports.default = function (formValues) {
  return [_extends({
    primary_applicant: true
  }, formValues.applicant[0], {
    country_code: 'CA',
    additional_data: _extends({
      school_name: (0, _url2.default)('tracking_code', null)
    }, formValues.applicant[0].additional_data, {
      relationship_to_student: formValues.applicant[0].additional_data.relationship_to_primary_applicant,
      country_of_origin: formValues.application.additional_data.country_of_origin
    })
  })].concat(_toConsumableArray(formValues.applicant.slice(1).map(function (applicant) {
    return _extends({}, applicant, {
      primary_applicant: false
    });
  })));
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/transformers/student/applicant.js
// module id = 1742
// module chunks = 0